module.exports = __webpack_public_path__ + "assets/media/evening.a03862ca.mp3";